"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummarizationOutputStyle = exports.SeparatorType = void 0;
var SeparatorType;
(function (SeparatorType) {
    SeparatorType[SeparatorType["TEXT"] = 0] = "TEXT";
    SeparatorType[SeparatorType["HTML"] = 1] = "HTML";
    SeparatorType[SeparatorType["MARKDOWN"] = 2] = "MARKDOWN";
    SeparatorType[SeparatorType["PYTHON"] = 3] = "PYTHON";
    SeparatorType[SeparatorType["JAVASCRIPT"] = 4] = "JAVASCRIPT";
    SeparatorType[SeparatorType["JAVA"] = 5] = "JAVA";
    SeparatorType[SeparatorType["GO"] = 6] = "GO";
    SeparatorType[SeparatorType["CPP"] = 7] = "CPP";
    SeparatorType[SeparatorType["LATEX"] = 8] = "LATEX";
    SeparatorType[SeparatorType["RST"] = 9] = "RST";
    SeparatorType[SeparatorType["RUBY"] = 10] = "RUBY";
    SeparatorType[SeparatorType["PROTO"] = 11] = "PROTO";
    SeparatorType[SeparatorType["SCALA"] = 12] = "SCALA";
    SeparatorType[SeparatorType["SOL"] = 13] = "SOL";
    SeparatorType[SeparatorType["SWIFT"] = 14] = "SWIFT";
})(SeparatorType = exports.SeparatorType || (exports.SeparatorType = {}));
var SummarizationOutputStyle;
(function (SummarizationOutputStyle) {
    SummarizationOutputStyle[SummarizationOutputStyle["BULLETED"] = 0] = "BULLETED";
    SummarizationOutputStyle[SummarizationOutputStyle["NUMBERED"] = 1] = "NUMBERED";
    SummarizationOutputStyle[SummarizationOutputStyle["PARAGRAPH"] = 2] = "PARAGRAPH";
})(SummarizationOutputStyle = exports.SummarizationOutputStyle || (exports.SummarizationOutputStyle = {}));
